export const LOGOUT_USER = "coinshift/logout/LOGOUT_USER";
